import {ITraveller} from "@/model/Traveller"

export interface IHasTravellersEligible {
    getTravellersEligible(): ITraveller[]
    getTravellersEligibleMap(): Map<string, ITraveller>
    addTravellerEligible(traveller: ITraveller): void
    removeTravellerEligible(traveller: ITraveller): void
}

function hasTravellersEligible<TBase extends Constructor>(Base: TBase) {
    
    class Bob extends Base implements IHasTravellersEligible {
        private travellersEligible: ITraveller[] = []
        private travellersEligibleMap: Map<string, ITraveller> = new Map()

        constructor(...args: any[]) {
            super(...args);
        }
        
        public getTravellersEligible(): ITraveller[] {
            return this.travellersEligible
        }
        public getTravellersEligibleMap(): Map<string, ITraveller> {
            return this.travellersEligibleMap
        }
        public addTravellerEligible(traveller: ITraveller): void {
            if (this.travellersEligibleMap.has(traveller.getId())) return
            this.travellersEligible.push(traveller)
            this.travellersEligibleMap.set(traveller.getId(), traveller)
        }
        public removeTravellerEligible(traveller: ITraveller): void {
            if (!this.travellersEligibleMap.has(traveller.getId())) return
            this.travellersEligible = this.travellersEligible.filter((_=>_.getId() !== traveller.getId()))
            this.travellersEligibleMap.delete(traveller.getId())
        }
    }
    return Bob
}

export default hasTravellersEligible